export const ru = {
  app: {
    title: 'Временная почта',
    subtitle:
      'Защитите свою почту от спама — используйте временную почту для регистрации на сайтах и сервисах и создавайте временные почтовые ящики',
    // Вариант с числом лимита из API (quota.active.limit). §promt-78 — без хардкода «50».
    subtitleCount:
      'Защитите свою почту от спама — используйте временную почту для регистрации на сайтах и сервисах, создавайте до {{count}} $t(plural.mailboxGen)',
    back: 'Назад',
  },
  // Универсальная русская плюрализация (i18next _one/_few/_many, Intl.PluralRules).
  // Вставляется через nesting: '{{count}} $t(plural.mailbox)'. §promt-78 §A5.
  plural: {
    mailbox_one: 'ящик',
    mailbox_few: 'ящика',
    mailbox_many: 'ящиков',
    // Родительный после «до N …»: «до 1 ящика», «до 5 ящиков».
    mailboxGen_one: 'почтового ящика',
    mailboxGen_few: 'почтовых ящиков',
    mailboxGen_many: 'почтовых ящиков',
    message_one: 'письмо',
    message_few: 'письма',
    message_many: 'писем',
    newAdj_one: 'новое',
    newAdj_few: 'новых',
    newAdj_many: 'новых',
    attachment_one: 'вложение',
    attachment_few: 'вложения',
    attachment_many: 'вложений',
    day_one: 'день',
    day_few: 'дня',
    day_many: 'дней',
    // Родительный после «в течение N …» / «не позднее N … назад».
    dayGen_one: 'дня',
    dayGen_few: 'дней',
    dayGen_many: 'дней',
  },
  nav: {
    account: 'Основной счёт',
  },
  auth: {
    login: 'Войти',
    logout: 'Выйти',
    loggingIn: 'Выполняется вход…',
    notAuthenticated: 'Вы не авторизованы',
    loginPrompt: 'Войдите через Keycloak, чтобы управлять почтовыми ящиками.',
    error: 'Не удалось войти. Попробуйте ещё раз.',
  },
  profile: {
    title: 'Профиль',
    email: 'Email',
    username: 'Имя пользователя',
    subject: 'Идентификатор (sub)',
  },
  subscriptions: {
    selectTitle: 'Выберите подписку',
    selectSubtitle:
      'К вашей учётной записи привязано несколько подписок «Временная почта». Выберите, с какой продолжить работу.',
    selectSubtitleEmpty:
      'К вашей учётной записи пока не привязана услуга «Временная почта».',
    continue: 'Продолжить',
    switch: 'Сменить подписку',
    one: 'Подписка',
    active: 'Текущая подписка',
    unnamed: 'Подписка без названия',
    defaultName: 'Временная почта {{n}}',
    renameTitle: 'Изменить название',
    renameField: 'Название',
    renameHint: 'Не больше {{max}} символов',
    renameRequired: 'Укажите название',
    renameFailed: 'Не удалось сохранить название',
    cardTitle: 'Карточка подписки',
    changePlanWithPartner: 'Чтобы сменить тариф, обратитесь к партнёру.',
    openMailboxes: 'Перейти к ящикам',
    statMailboxes: 'Почтовых ящиков',
    statUsed: 'Занято',
    statFree: 'Свободно из {{limit}} МБ',
    statForwarded: 'С переадресацией',
    statOf: 'из',
    statMb: 'МБ',
    empty: 'Нет доступных подписок. Подключите услугу в кабинете или обновите страницу.',
    loadError: 'Не удалось загрузить список подписок',
    deeplinkDenied:
      'Ссылка ведёт на подписку, которая недоступна вашей учётной записи. Выберите подписку из списка ниже.',
    deeplinkUnavailable:
      'Не удалось проверить, доступна ли подписка из ссылки. Попробуйте позже или выберите подписку из списка ниже.',
    status: {
      active: 'Активна',
      suspended: 'Приостановлена',
      pending_cancellation: 'Ожидает отключения',
      terminated: 'Отключена',
    },
  },
  notifications: {
    title: 'Уведомления',
    empty: 'Новых уведомлений нет',
    clear: 'Очистить',
    newMessage: 'Новое письмо',
    noSubject: 'Без темы',
    // Lifecycle-уведомления (promt-78 §C). Вложенная структура — чтобы точки в типе
    // (mailbox.expiring и т.п.) корректно резолвились ключом i18next.
    lifecycle: {
      mailbox: {
        expiring: {
          title: 'Срок активации истекает',
          body: 'Ящик {{address}} деактивируется через {{minutes}} мин',
        },
        size: {
          threshold: {
            title: 'Ящик почти заполнен',
            body: 'Ящик {{address}} заполнен на {{percent}}%',
          },
        },
      },
      subscription: {
        quota: {
          warning: {
            title: 'Лимит трафика скоро будет достигнут',
            body: 'Использовано {{used}} из {{limit}} Мб, осталось {{remaining}} Мб',
          },
          reached: {
            title: 'Достигнут лимит трафика',
            body: 'Использовано {{used}} из {{limit}} Мб. Приём писем приостановлен, ящики деактивированы',
          },
        },
      },
    },
  },
  common: {
    yes: 'Да',
    no: 'Нет',
    cancel: 'Отмена',
    save: 'Сохранить',
    delete: 'Удалить',
    edit: 'Редактировать',
    loading: 'Загрузка…',
    error: 'Произошла ошибка',
    retry: 'Попробовать ещё раз',
    copy: 'Скопировать адрес',
    copied: 'Скопировано',
    showMore: 'Показать ещё',
    selectAll: 'Выбрать все',
    close: 'Закрыть',
  },
  theme: { toggle: 'Сменить тему', light: 'Светлая', dark: 'Тёмная' },
  mailbox: {
    pageTitle: 'Временная почта',
    headerCard: 'Почтовые ящики',
    addMailbox: '+ Добавить почту',
    quotaRemaining: 'Осталось {{remaining}} из {{total}} Мб {{period}}',
    quotaTooltip: 'Лимит объёма входящих писем {{total}} Мб {{period}}. {{reset}}',
    limitReached: 'Достигнут лимит на создание ящиков',
    limitTooltip:
      'Достигнут лимит на количество почтовых ящиков. Чтобы создать новый, удалите хотя бы один из существующих',
    limitTooltipBefore: 'Достигнут лимит на количество почтовых ящиков. Чтобы создать новый, ',
    limitTooltipAction: 'удалите',
    limitTooltipAfter: ' хотя бы один из существующих',
    forwardingBanner: 'Настройте автоматическую переадресацию на ваш личный почтовый ящик',
    forwardingBannerActive: 'Пересылаем письма с выбранных временных ящиков на {{email}}',
    forwardingSetup: 'Настроить',
    sectionPinned: 'Закреплённые',
    sectionAll: 'Все ящики',
    restoreDeleted: 'Восстановить удалённые',
    noNew: 'Нет новых',
    newCount: '{{count}} $t(plural.newAdj)',
    forwardedHint: 'Письма уходят на основную почту',
    emptyTitle: 'Почтовых ящиков ещё нет',
    emptySubtitle: 'Создайте свой первый временный почтовый ящик',
    emptySubtitleRestore: 'Создайте первую временную почту или восстановите старые ящики',
    emptyRestore: '↺ Восстановить старые ящики',
    menu: {
      pin: 'Закрепить',
      unpin: 'Открепить',
      activate: 'Активировать',
      enableForwarding: 'Включить переадресацию',
      disableForwarding: 'Отключить переадресацию',
      setupForwarding: 'Настроить переадресацию',
      delete: 'Удалить ящик',
    },
    create: {
      title: 'Создание почтового ящика',
      subtitle: 'Придумайте адрес самостоятельно или сгенерируйте его автоматически',
      aliasLabel: 'Введите адрес',
      aliasPlaceholder: 'Например, dobryy-kot-24',
      domainLabel: 'Домен',
      regenerate: 'Сгенерировать ещё',
      descriptionPlaceholder: 'Добавьте описание почтового ящика',
      submit: 'Создать',
      checking: 'Проверяем адрес…',
      errors: {
        empty: 'Введите адрес почтового ящика',
        already_exists: 'Этот адрес почты уже занят',
        frozen: 'Этот адрес восстановится {{date}}',
        in_trash: 'Этот адрес находится в вашей корзине. Восстановите ящик или выберите другой адрес',
        in_trash_until:
          'Этот адрес находится в вашей корзине (можно восстановить до {{date}}). Восстановите ящик или выберите другой адрес',
        regex_invalid: 'Адрес может содержать только латинские буквы, цифры, точку и дефис (3–64 символа)',
        descriptionTooLong: 'Описание не должно превышать {{max}} символов',
        quota: 'Достигнут лимит — {{count}} $t(plural.mailbox). Удалите ненужные.',
        system:
          'Во время создания временного почтового ящика произошла ошибка. Мы уже работаем над её исправлением. Попробуйте создать ящик ещё раз',
      },
    },
    delete: {
      title: 'Вы действительно хотите удалить ящик {{address}}?',
      subtitle: 'После удаления его можно будет восстановить в течение {{count}} $t(plural.dayGen)',
      confirm: 'Удалить',
    },
    restore: {
      title: 'Восстановление ящиков',
      subtitle:
        'Можете восстановить свои почтовые ящики, удалённые не позднее {{count}} $t(plural.dayGen) назад',
      listHint: 'Названия старых почтовых ящиков:',
      limitInfo: 'Свободно слотов для восстановления: {{count}} из {{limit}}',
      limitTooltip:
        'Ограничено лимитом на количество активных ящиков: занятые слоты недоступны, лишние чекбоксы блокируются',
      duplicateDisabled: 'Адрес уже выбран для восстановления в другом ящике',
      empty: 'Удалённых ящиков нет',
      submit: 'Восстановить',
    },
    bulkCleanup: {
      title: 'Удалите ненужные почтовые ящики',
      subtitle: 'Для удобства мы нашли ящики без писем или которые не использовались длительное время',
      submit: 'Удалить',
    },
    description: {
      title: 'Описание почтового ящика',
      placeholder: 'Добавьте описание',
      add: 'Добавить описание',
    },
    toasts: {
      created: 'Ящик создан',
      createError: 'Ошибка создания ящика',
      createErrorBody:
        'Во время создания временного почтового ящика произошла ошибка. Мы уже работаем над её исправлением. Попробуйте создать ящик ещё раз',
      deleted: 'Ящик удалён',
      restored: 'Ящик восстановлен',
      pinned: 'Ящик закреплён',
      unpinned: 'Ящик откреплён',
      pinLimitTitle: 'Достигнут лимит',
      pinLimitBody:
        'К сожалению, закрепить можно не больше 3 ящиков. Открепите хотя бы один из ящиков, чтобы закрепить новый',
      activated: 'Ящик активирован',
      extended: 'Срок активности продлён',
      forwardingOn: 'Переадресация включена',
      forwardingOff: 'Переадресация отключена',
      restorePartial: 'Восстановлено {{ok}} из {{total}}. Часть адресов уже занята',
      restoreError: 'Не удалось восстановить ящики',
    },
  },
  message: {
    activateMailbox: 'Активировать почту',
    extendMailbox: 'Продлить',
    emptyTitle: 'Писем пока нет',
    emptySubtitle: 'Новые письма будут отображаться здесь',
    trashEmptyTitle: 'Корзина пуста',
    trashEmptySubtitle: 'Удалённые письма будут отображаться здесь',
    forwardedEmptyTitle: 'Письма уходят на основную почту',
    forwardedEmptySubtitle: 'Пока включена переадресация, входящие письма этого ящика не отображаются здесь',
    trashRetentionHint:
      'Письма, хранящиеся в корзине более {{count}} $t(plural.dayGen), удаляются автоматически',
    attachments: '{{count}} $t(plural.attachment)',
    tabs: {
      inbox: 'Входящие',
      trash: 'Удалённые',
    },
    select: 'Выбрать',
    selectAll: 'Выбрать все',
    selectCancel: 'Отменить',
    restore: 'Восстановить',
    bulk: {
      delete: 'Удалить',
      deleteForever: 'Удалить навсегда',
      read: 'Прочитано',
      restore: 'Восстановить',
    },
    purge: {
      title: 'Удалить навсегда {{count}} $t(plural.message)?',
      subtitle:
        'Письма будут удалены безвозвратно: их нельзя будет восстановить или открыть по ссылке. Освободившееся место снова станет доступно для приёма новых писем.',
      confirm: 'Удалить навсегда',
    },
    menu: {
      enableForwarding: 'Включить переадресацию',
      disableForwarding: 'Отключить переадресацию',
      setupForwarding: 'Настроить переадресацию',
      markAllRead: 'Отметить всё как прочитанное',
      deleteAll: 'Удалить все письма',
      deleteMailbox: 'Удалить почтовый ящик',
    },
    detail: {
      attachmentsTitle: 'Вложения',
      downloadAll: 'Скачать все',
      download: 'Скачать',
      delete: 'Удалить письмо',
      noSubject: '(без темы)',
    },
    toasts: {
      deleted: 'Письмо удалено',
      deletedAll: 'Все письма удалены',
      markedAllRead: 'Все письма прочитаны',
      restored: 'Письмо восстановлено',
      bulkDeleted: 'Удалено {{count}} $t(plural.message)',
      bulkRead: 'Отмечено прочитанными: {{count}} $t(plural.message)',
      bulkRestored: 'Восстановлено {{count}} $t(plural.message)',
      bulkPurged: 'Удалено навсегда: {{count}} $t(plural.message)',
    },
  },
  status: {
    active: 'Активен',
    activeSoon: 'Активен ещё {{time}}',
    activeFemale: 'Активна',
    activeSoonFemale: 'Активна ещё {{time}}',
    inactive: 'Неактивен',
    forwarding: 'Переадресация',
  },
  forwarding: {
    title: 'Настройки переадресации',
    subtitle:
      'Управляйте переадресацией через настройки — подтвердите основной адрес почты и выберите временные ящики, с которых хотите пересылать письма',
    primaryTitle: 'Адрес основной почты',
    primaryEmptyHint:
      'Укажите и подтвердите основной адрес электронной почты, на которую будут пересылаться письма с активных временных ящиков',
    primarySetHint: 'Автоматически будем пересылать письма с выбранных временных ящиков на почту {{email}}',
    addPrimary: '+ Добавить почту',
    changePrimary: 'Изменить почту',
    unbindPrimary: 'Отвязать почту',
    pending: 'Ожидает подтверждения',
    enterCode: 'Ввести код',
    manageTitle: 'Управление переадресацией',
    manageHint:
      'Выберите ящики, с которых будут пересылаться письма на основную почту (обратите внимание, что переадресация работает только с активных ящиков)',
    manageDisabledHint:
      'Сначала добавьте и подтвердите основной адрес почты — после этого можно будет включить переадресацию для ящиков',
    otp1: {
      title: 'Шаг 1. Введите адрес основной почты',
      subtitle:
        'Заполните адрес электронной почты, на которую хотите переадресовывать входящие письма с этого почтового ящика — мы отправим на него письмо с кодом подтверждения',
      emailPlaceholder: 'Введите адрес почты',
      submit: 'Получить код',
      invalid: 'Введите корректный адрес электронной почты',
    },
    otp2: {
      title: 'Шаг 2. Введите код из письма',
      subtitle: 'Введите код подтверждения из письма с почтового ящика {{email}}',
      submit: 'Подтвердить',
      resend: 'Отправить код повторно',
      wrong: 'Неверный код. Осталось попыток: {{attempts}}',
      invalid: 'Неверный код подтверждения',
      expired: 'Срок действия кода истёк. Запросите новый',
      expiresIn: 'Код действует ещё {{time}}',
    },
    success: { title: 'Адрес почты подтверждён', goToMailboxes: 'Перейти к ящикам' },
    change: {
      title: 'Вы действительно хотите изменить основной адрес почты {{email}}?',
      subtitle: 'После этого пересылка со всех временных ящиков будет отключена',
      confirm: 'Изменить',
    },
    unbind: {
      title: 'Вы действительно хотите отвязать основной адрес почты {{email}}?',
      subtitle: 'После этого пересылка со всех временных ящиков будет отключена',
      confirm: 'Отвязать',
    },
    toasts: {
      confirmed: 'Переадресация на почту {{email}} настроена',
      on: 'Переадресация временного ящика {{address}} с основной почтой {{email}} настроена',
      off: 'Переадресация временного ящика {{address}} с основной почтой {{email}} отключена',
      unbound: 'Основной адрес почты отвязан',
      otpSent: 'Код подтверждения отправлен повторно',
    },
  },
  quota: {
    // Период трафик-лимита (config-driven, quota.traffic.period). §promt-78 §B.
    period: { day: 'в сутки', month: 'в этом месяце' },
    periodReset: {
      day: 'Через сутки лимит будет обновлён',
      month: '1 числа следующего месяца лимит будет обновлён',
    },
    warningTitle: 'Лимит трафика заканчивается',
    warningBody:
      'Осталось менее 5 Мб на приём новых писем. Обратите внимание, что новые тяжёлые письма могут не приходить',
    pausedTitle: 'Получение новых писем приостановлено до {{date}}',
    // Динамический текст сброса лимита в зависимости от типа периода (promt-80 §1).
    resetInTimer: 'Лимит обновится через {{timer}}, и активные ящики снова начнут принимать письма',
    resetInDays:
      'Лимит обновится через {{count}} $t(plural.day), и активные ящики снова начнут принимать письма',
    pausedDetails: 'Подробнее',
    pausedModal: {
      title: 'Приём новых писем на паузе до {{date}}',
      subtitle: '{{reset}}.',
      canTitle: 'Чем можно пользоваться:',
      can: 'Чтением уже полученных писем\nСоздавать новые почтовые ящики\nКопировать адреса ящиков\nОсвобождать место, удаляя письма из корзины навсегда',
      pausedColTitle: 'Что на паузе:',
      pausedCol: 'Получение новых входящих писем',
      noteTitle: 'Как освободить место',
      note: 'Мы считаем объём уже полученных за период писем. Письма в корзине по-прежнему занимают место — удалите ненужные письма из корзины навсегда, и освободившийся объём сразу станет доступен для приёма новых писем. Также лимит полностью обновится в начале нового периода',
    },
  },
  onboarding: {
    common: {
      tourName: 'Временная почта',
      counter: '{{current}} из {{total}}',
      next: 'Дальше',
      done: 'Готово',
      close: 'Закрыть подсказки',
      replay: 'Показать подсказки',
    },
    tempmailMain: {
      mailboxCreateFirst: {
        title: 'Создание ящиков',
        body: 'Создайте свой первый адрес. Всего можно завести до {{limit}} ящиков. Помните: каждый из них активно принимает письма только {{minutes}} минут, а затем «засыпает».',
      },
      mailboxCreate: {
        title: 'Создание ящиков',
        body: 'Здесь вы можете создавать новые почтовые ящики. Всего можно создать до {{limit}} адресов. Помните: каждый из них активно принимает письма только {{minutes}} минут, а затем «засыпает».',
      },
      quotaTraffic: {
        title: 'Использование трафика',
        body: '{{traffic}} Мб — это объём входящих писем. Удаление старых писем не вернёт мегабайты (как мобильный Интернет). {{reset}}.',
      },
      forwardingIntro: {
        title: 'Пересылка писем',
        body: 'Укажите вашу основную почту и подтвердите её кодом — это нужно сделать один раз, чтобы система знала, куда отправлять письма.',
      },
      mailboxManage: {
        title: 'Управление ящиком',
        body: 'Здесь вы можете настроить ваш почтовый ящик — закрепить его, включить/отключить переадресацию писем на указанный адрес, активировать или удалить.',
      },
    },
  },
  errors: {
    notFoundTitle: 'Страница не найдена',
    notFoundSubtitle: 'Возможно, вы перешли по устаревшей ссылке',
    notFoundCta: 'На главную',
    genericTitle: 'Что-то пошло не так',
    genericSubtitle: 'Мы уже знаем о проблеме и работаем над ней',
    genericCta: 'Попробовать ещё раз',
    rateLimited: 'Слишком много запросов. Повторите чуть позже',
    unavailable: 'Сервис временно недоступен',
  },
} as const;
